/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Company } from './company';
import { Customer } from './customer';
import { LicensePlate } from './license-plate';
import { Person } from './person';
import { RentalCarContract } from './rental-car-contract';
import { RepairShop } from './repair-shop';
import { Vehicle } from './vehicle';

/**
 * 
 * @export
 * @interface DamageCase
 */
export interface DamageCase {
    /**
     * 
     * @type {number}
     * @memberof DamageCase
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DamageCase
     */
    'imdNetId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DamageCase
     */
    'state'?: DamageCaseStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCase
     */
    'isPersonInjured': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DamageCase
     */
    'isRecordedByPolice': boolean;
    /**
     * 
     * @type {LicensePlate}
     * @memberof DamageCase
     */
    'oppositeLicensePlate'?: LicensePlate;
    /**
     * 
     * @type {Person}
     * @memberof DamageCase
     */
    'oppositePerson'?: Person;
    /**
     * 
     * @type {number}
     * @memberof DamageCase
     */
    'date': number;
    /**
     * 
     * @type {string}
     * @memberof DamageCase
     */
    'accidentLocation'?: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof DamageCase
     */
    'vehicle'?: Vehicle;
    /**
     * 
     * @type {Customer}
     * @memberof DamageCase
     */
    'customer': Customer;
    /**
     * 
     * @type {Company}
     * @memberof DamageCase
     */
    'lawyerOffice'?: Company;
    /**
     * 
     * @type {string}
     * @memberof DamageCase
     */
    'lawyerOfficeReferenceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCase
     */
    'damageAssessorReferenceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DamageCase
     */
    'repairShopReferenceNumber'?: string;
    /**
     * 
     * @type {Person}
     * @memberof DamageCase
     */
    'customerConsultant'?: Person;
    /**
     * 
     * @type {Company}
     * @memberof DamageCase
     */
    'oppositeInsurance'?: Company;
    /**
     * 
     * @type {RepairShop}
     * @memberof DamageCase
     */
    'repairShop'?: RepairShop;
    /**
     * 
     * @type {Company}
     * @memberof DamageCase
     */
    'damageAssessor'?: Company;
    /**
     * 
     * @type {RentalCarContract}
     * @memberof DamageCase
     */
    'rentalCarContract'?: RentalCarContract;
}

export const DamageCaseStateEnum = {
    Wait: 'wait',
    Repair100: 'repair_100',
    Repair130: 'repair_130',
    WriteOff: 'write_off'
} as const;

export type DamageCaseStateEnum = typeof DamageCaseStateEnum[keyof typeof DamageCaseStateEnum];


